import * as React from "react";

import { GlobalsContext } from "kw/util/Globals";
import {
  HeadingLarge,
  HeadingMedium,
  ParagraphXSmall,
} from "kanopi-components/typography";
import { List } from "kanopi-components/List";
import { Callout } from "kanopi-components/Callout";
import { PortalRow } from "kanopi-components/PortalRow";
import { PolicyFixedFooter } from "kw/policies/components/PolicyFixedFooter";
import { NavButton } from "kw/components/NavButton/NavButton";
import { ContactUsModal } from "kw/components/ContactUs/ContactUs";
import { navigate } from "@reach/router";

type TIntroPageProps = {
  policyId: string;
};

export const IntroPage = ({ policyId }: TIntroPageProps) => {
  const handleStartClaimCb = React.useCallback(() => {
    navigate(`/claims/make-a-claim/${policyId}/details/`);
  }, [policyId]);

  return (
    <GlobalsContext.Provider value="claims">
      <PortalRow>
        <HeadingMedium center marginTop={0} marginBottom={0}>
          Before we start...
        </HeadingMedium>
        <HeadingLarge center marginTop={0}>
          What to expect when you make a claim
        </HeadingLarge>
      </PortalRow>
      <PortalRow>
        <List
          items={[
            {
              title: "You'll need",
              markdown: `
- Your policy document
- Receipts for anything stolen or damaged
- Reference numbers - for example, if you filed a policy report
            `,
            },
            {
              title: "Lodge your claim",
              markdown: `
- Your policy document
- Receipts for anything stolen or damaged
- Reference numbers - for example, if you filed a policy report
            `,
            },
            {
              title: "We'll take it from there",
              markdown: `
- Your policy document
- Receipts for anything stolen or damaged
- Reference numbers - for example, if you filed a policy report
            `,
            },
          ]}
        />
      </PortalRow>
      <PortalRow>
        <Callout>
          <ParagraphXSmall marginTop={0} marginBottom={0}>
            Got any questions? <ContactUsModal /> and we are happy to assist you with
            your claim.
          </ParagraphXSmall>
        </Callout>
      </PortalRow>
      <PolicyFixedFooter>
        <NavButton onClick={handleStartClaimCb} data-testid="startClaimCta">
          Start your claim
        </NavButton>
      </PolicyFixedFooter>
    </GlobalsContext.Provider>
  );
};
